if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;

      // existing
      this.columnsDesktop = this.dataset.columnsDesktop;

      // new optional attributes
      this.columnsTablet = this.dataset.columnsTablet || null;
      this.columnsMobile = this.dataset.columnsMobile || null;

      this.slidesPerView = this.dataset.slides;

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    // init() {
    //   if (FoxTheme.config.mqlMobile) {
    //     this.destroySlider();
    //   } else {
    //     this.initSlider();
    //   }
    // }
init() {
  const enableOnMobile = this.dataset.enableMobile === "true";

  if (!enableOnMobile && window.innerWidth < 768) {
    // mobile + not enabled → destroy
    this.destroySlider();
  } else {
    // all other cases → run
    this.initSlider();
  }
}

    initSlider() {
      const sliderOptions = {
        modules: [
          FoxTheme.Swiper.Navigation,
          FoxTheme.Swiper.Pagination,
          FoxTheme.Swiper.Mousewheel,
        ],
        // no base slidesPerView here – handled in breakpoints
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          // ✅ Explicit mobile config
          0: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsMobile ? this.columnsMobile : 2.5)
                : 'auto',
          },
          768: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsTablet
                    ? this.columnsTablet
                    : this.columnsDesktop > 4
                    ? 4
                    : this.columnsDesktop)
                : 'auto',
          },
          1024: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? (this.columnsTablet
                    ? this.columnsTablet
                    : this.columnsDesktop > 6
                    ? this.columnsDesktop - 1
                    : this.columnsDesktop)
                : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        // ✅ Log current breakpoint params
        console.log(
          "✅ Active Swiper params on load:",
          this.sliderInstance.slider.params
        );
        console.log("📏 Window width:", window.innerWidth);

        // ✅ Log when breakpoint changes
        this.sliderInstance.slider.on("breakpoint", (swiper, breakpointParams) => {
          let label = "Unknown";
          const w = window.innerWidth;
          if (w < 768) label = "Mobile (<768)";
          else if (w < 1024) label = "Tablet (768–1023)";
          else if (w < 1280) label = "Small Desktop (1024–1279)";
          else label = "Desktop (1280+)";
          console.log("📐 Breakpoint applied:", label, breakpointParams);
          console.log("👉 Slides per view:", swiper.params.slidesPerView);
        });

        // ✅ Log on every resize too (so you see updates even if no breakpoint fired)
        this.sliderInstance.slider.on("resize", (swiper) => {
          let label = "Unknown";
          const w = window.innerWidth;
          if (w < 768) label = "Mobile (<768)";
          else if (w < 1024) label = "Tablet (768–1023)";
          else if (w < 1280) label = "Small Desktop (1024–1279)";
          else label = "Desktop (1280+)";
          console.log(
            `📏 Resize → ${label}, slidesPerView: ${swiper.params.slidesPerView}, width: ${w}px`
          );
        });

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener("focusin", () => {
            const slide = element.closest(".swiper-slide");
            this.sliderInstance.slider.slideTo(
              this.sliderInstance.slider.slides.indexOf(slide)
            );
          });
        });

        if (Shopify.designMode) {
          document.addEventListener("shopify:block:select", (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
